module.exports = __webpack_public_path__ + "img/goralex-php.e7be4324.jpg";